// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/changeElement.scss'
import VueAMap from "vue-amap"
import App from './App'
import api from './api/index'
import promise from 'es6-promise'
import './assets/css/style.scss'
import axios from 'axios';
import vueEsign from 'vue-esign'
import DirectionImageDialog from './components/common/DirectionImageDialog'

Vue.use(vueEsign)
Vue.prototype.$axios = axios;
Vue.component('direction-image-dialog', DirectionImageDialog)

 
Vue.config.productionTip = false;

promise.polyfill()
Vue.use(ElementUI)
Vue.use(VueAMap)

VueAMap.initAMapApiLoader({
  key: 'da6aa8afb6472e4745e438b80568fe90',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch','AMap.Geolocation','AMap.Geocoder','AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  uiVersion: '1.0.11'// 引入地图UI组件
})
//'da670418fb3217e01e51bb5992d14f99'个人
//'da6aa8afb6472e4745e438b80568fe90',公司
Vue.prototype.HttpFn = api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
	store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js